module.exports = __webpack_public_path__ + "static/media/22ESCWA3.e2854ff4.jpg";